import "@lottiefiles/lottie-player";
import LottieInteractivity from '@lottiefiles/lottie-interactivity';
import {create} from "@lottiefiles/lottie-interactivity";
const initLottiefiles = () => {
  let lottie1, lottie2 = null;
  const sandLottieSection = document.querySelector("#sandLottieSection");
  if(document.querySelector('.sand-scroll-animation-list')){
    const screatLottie = () =>{
      lottie1 = create({
        mode: "scroll",
        player: "#firstLottie",
        container: "#sandLottieContainer",
        actions: [
          {
            speed: [1],
            visibility: [0.05, 1],
            type: "seek",
            frames: [0, 600]
          }
        ]
      });
      lottie2 = create({
        mode: "scroll",
        player: "#secondLottie",
        container: "#sandLottieContainer",
        actions: [
          {
            speed: [1],
            visibility: [0.05, 1],
            type: "seek",
            frames: [0, 600]
          }
        ]
      });


    }

    const scrollEvent = () =>{
      const elemTopDistance = sandLottieSection.offsetTop;
      window.addEventListener("scroll", function() {
        if ((window.scrollY + 200) > elemTopDistance) {
          document.querySelector('#sandLottieElements').classList.add('active');
        } else {
          document.querySelector('#sandLottieElements').classList.remove('active');
        }
      });
    }
    scrollEvent();
    screatLottie();

    window.addEventListener('resize', scrollEvent);
  }
};
export default initLottiefiles;
